// extracted by mini-css-extract-plugin
export default {"container":"ConfirmQrRequest_container__xvGJ0"};